import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'

export default {
  data() {
    return {
      SCOPES: FILTER_CONSTANTS.SCOPE,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      availableScopes: APP_GETTERS.AVAILABLE_SCOPES,
    }),
  },
  methods: {
    hasScope(scope) {
      return this.availableScopes.includes(scope)
    },
  },
}
